import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loginComponent from './login.component';

const loginModule = angular.module('tinaba.components.login', [
  uiRouter
])

// .config(($stateProvider) => {
//   'ngInject';
//
//   $stateProvider
//     .state('login', {
//       url: '/login',
//       template: '<login></login>'
//     });
// })

.component('login', loginComponent);

export default loginModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/login/login.js
 **/